import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  name: 'Sam & Heather',
  text: 'Copper & Stone made our move to Broomfield incredibly smooth. Their market knowledge and professionalism took all the stress out of the process. We felt completely supported from day one.'
}, {
  name: 'Jason',
  text: 'Selling a home can be daunting, but the team at Copper & Stone provided a clear strategy and editorial-quality marketing that got us top dollar. Highly recommend their services.'
}, {
  name: 'Erinn & Dan',
  text: 'A truly boutique experience. They listened to exactly what we wanted in a foothills property and found us a hidden gem. Their negotiation skills are unmatched.'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section className="py-24 md:py-32 bg-brand-cream relative overflow-hidden" data-id="element-175">
      {/* Decorative large quote mark background */}
      <div className="absolute top-10 left-10 md:left-20 text-[200px] md:text-[300px] leading-none font-serif text-brand-copper/5 select-none pointer-events-none" data-id="element-176">
        "
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-177">
        <div className="text-center mb-16" data-id="element-178">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal" data-id="element-179">
            What our clients say
          </h2>
        </div>

        <div className="max-w-4xl mx-auto relative" data-id="element-180">
          <div className="overflow-hidden" data-id="element-181">
            <div className="flex transition-transform duration-500 ease-in-out" style={{
            transform: `translateX(-${currentIndex * 100}%)`
          }} data-id="element-182">
              {testimonials.map((t, i) => <div key={i} className="w-full flex-shrink-0 px-4 md:px-12 text-center" data-id="element-183">
                  <div className="text-brand-copper text-6xl font-serif mb-6 leading-none" data-id="element-184">
                    "
                  </div>
                  <p className="text-xl md:text-3xl font-serif text-brand-charcoal leading-relaxed mb-10" data-id="element-185">
                    {t.text}
                  </p>
                  <div className="text-brand-taupe font-medium tracking-widest uppercase text-sm" data-id="element-186">
                    — {t.name}
                  </div>
                </div>)}
            </div>
          </div>

          {/* Controls */}
          <div className="flex items-center justify-center gap-8 mt-12" data-id="element-187">
            <button onClick={prev} className="p-2 text-brand-taupe hover:text-brand-copper transition-colors" data-id="element-188">
              <ChevronLeft size={32} data-id="element-189" />
            </button>
            <div className="flex gap-3" data-id="element-190">
              {testimonials.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`w-2.5 h-2.5 rounded-full transition-colors ${i === currentIndex ? 'bg-brand-copper' : 'bg-brand-taupe/30'}`} aria-label={`Go to slide ${i + 1}`} data-id="element-191" />)}
            </div>
            <button onClick={next} className="p-2 text-brand-taupe hover:text-brand-copper transition-colors" data-id="element-192">
              <ChevronRight size={32} data-id="element-193" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}